import { H1, LoadingSpinner, SiteContainer, Text } from "atoms";
import { useAuthHasRole } from "features/auth";
import { Navigate } from "react-router-dom";
import {
  Review,
  usePendingReviews,
  ArtistReview,
  ProjectReview,
  useReviewModeration,
} from "features/reviews";

function Moderation() {
  const isModerator = useAuthHasRole([
    "curator-level-2",
    "curator-level-3",
    "admin",
  ]);
  const { data, isLoading } = usePendingReviews();
  const review = data?.data[0];

  // Subscribe to moderation messages from web socket
  useReviewModeration();

  if (!isModerator) {
    return <Navigate to="/" replace />;
  }

  return (
    <main>
      <SiteContainer width="md">
        <H1>Moderation</H1>

        <Text>
          Reviews must be moderated before they are visible to all users. You
          will see one review at a time.
        </Text>
        <Text>
          Click to <strong>Upvote</strong> if you feel the review meets the HUG
          standards, or click <strong>Downvote</strong> if you feel the review
          is not worthy. Reviews with three downvotes will be removed from the
          system, and reviews with three upvotes will be visible to all users.
          You will earn 30 HUG Points for each review you moderate. Points are
          only rewarded before reviews are rejected or published.
        </Text>
        <Text>
          There are {data?.notModeratedAvailable || 0} reviews you can moderate
          out of a total of {data?.notModeratedTotal || 0} pending reviews. You
          cannot moderate your own reviews, and cannot moderate reviews you have
          already voted for.
        </Text>

        {isLoading && <LoadingSpinner />}

        {!!review && (
          <div className="Moderation">
            <Review
              review={review as ArtistReview | ProjectReview}
              showParent
              alwaysShowStatus
            />
          </div>
        )}
      </SiteContainer>
    </main>
  );
}

export { Moderation };
